export default "__VITE_ASSET__DxFqpTJi__"